<template>
    <div class="home-wrapper">
        <div class="home">
            <!-- 轮播图 -->
            <section class="home-carousel">
                <Carousel />
            </section>
            <!-- <section class="home-type">
                <router-link :key="item.info" class="type-item" target="_blank" v-for="item in typeList" :to="item.url">
                    <img :src="item.imgUrl" alt="">
                    <div class="type-title">{{item.title}}</div>
                    <div class="type-desc">
                        <div class="type-info">
                            <div>{{item.info}}</div>
                            <div>{{item.desc}}</div>
                        </div>
                        <div class="type-btn">查看详情</div>
                    </div>
                </router-link>
            </section> -->
            <section class="home-inside">
                <!-- 首页推荐 -->
                <div class="home-nav">
                    <ul class="home-nav__list">
                        <li :class="{ active: navStatus === 0 }" @click="navStatus = 0">
                            为你推荐
                        </li>
                        <li :class="{ active: navStatus === 1 }" @click="navStatus = 1">
                            推荐作品
                        </li>
                        <li :class="{ active: navStatus === 2 }" @click="navStatus = 2">
                            推荐经验
                        </li>
                        <li :class="{ active: navStatus === 3 }" @click="handleFollowTag">
                            我的关注
                        </li>
                    </ul>
                </div>
                <!-- 首页推荐-内容部分 -->
                <card-list :type="navStatus"></card-list>
                <!-- 广告位 -->
                <!-- <ad-list /> -->
                <!-- 热门素材 -->
                <hot-material />
                <!-- 精选源码 -->
                <hot-source-code />
                <!-- 热门课程 -->
                <!-- <hot-course /> -->
            </section>
        </div>
        <!-- 侧边栏 -->
        <!-- <div class="aside">
            <yellow-calendar class="aside-item"></yellow-calendar>
            <aside-tag class="aside-item"></aside-tag>
            <aside-graphic class="aside-item"></aside-graphic>
            <aside-banner class="aside-item"></aside-banner>
        </div> -->
    </div>
</template>

<script>
import Carousel from './components/Carousel';
import CardList from './components/CardList';
import AsideTag from '@/views/components/AsideTag';
// import AsideGraphic from '@/views/components/AsideGraphic';
// import AsideBanner from '@/views/components/AsideBanner';
// import YellowCalendar from './components/YellowCalendar';
import HotMaterial from './components/HotMaterial';
import HotCourse from './components/HotCourse';
import hotSourceCode from './components/hotSourceCode';
// import adList from './components/adList';
import { getUrlData } from '@/utils/utils';
import { getToken } from '@/utils/auth';
import { mapActions } from 'vuex';

export default {
    name: 'Home',
    components: {
        Carousel,
        CardList,
        AsideTag,
        // AsideGraphic,
        // AsideBanner,
        // YellowCalendar,
        // adList,
        HotMaterial,
        HotCourse,
        hotSourceCode
    },
    inject: ['checkToken'],
    data: () => ({
        navStatus: 0,
        typeList:[
            {
                imgUrl: "/static/images/type1.png",
                title: "项目案例",
                url:"/projectCase",
                info: "可视化项目设计开发多样化服务",
                desc:"多行业可视化项目案例，一键选同款",
            },
            {
                imgUrl: "/static/images/type2.png",
                title: "精品素材",
                url:"/material",
                info: "近千个高质量设计素材下载",
                desc:"大屏PSD文件、多样式组件、矢量地图…",
            },
            {
                imgUrl: "/static/images/type3.png",
                title: "精品课程",
                url:"/courses",
                info: "超过3327位学员已学习过",
                desc:"超全可视化设计开发0到1全流程教学",
            },
        ]
    }),
    created(){
        this.navStatus = Number(sessionStorage.getItem('navStatus')) || 0
        let code = getUrlData('code');
        if(code){
            this.wxLoginResult(code);
        }
    },
    watch:{
        navStatus(newVal){
            sessionStorage.setItem('navStatus',newVal)
        }
    },
    methods: {
        ...mapActions('user', ['WxLogin']),
        handleFollowTag() {
            if (this.checkToken()) {
                this.navStatus = 3;
            }
        },
        wxLoginResult(code){
            const token = getToken();
            this.WxLogin({code,token}).then((res)=>{
                if(res.code === 0){
                    localStorage.setItem('userId', res.data.id)
                    this.$store.dispatch('user/getUserInfo');
                    this.$message.success({
                        message: '登录成功',
                        duration: 1000
                    });
                    setTimeout(() => {
                        let path = localStorage.getItem('path');
                        window.location.replace(`/#${path}`);
                    },600)
                }else if(res.code === 11){
                    sessionStorage.setItem('openId', res.data.openid);
                    sessionStorage.setItem('nickName', res.data.nickname);
                    window.location.replace('/#/loginPage/wxLogin');
                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.home-wrapper {
    display: flex;

    .home {
        width: 1600px;
        &-type {
            display: flex;
            justify-content: space-between;
            height: 200px;
            margin: 20px 0 30px 0;
            .type-item {
                // flex: 1;
                width: 412px;
                height: 200px;
                margin-right: 20px;
                position: relative;
                padding: 20px;
                display: flex;
                justify-content: flex-end;
                flex-direction: column;
                cursor: pointer;
                box-sizing: border-box;
                &:nth-last-child(1) {
                    margin: 0;
                }
                img {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 8px;
                    z-index: 1;
                }
                .type-title {
                    position: relative;
                    z-index: 2;
                    color: #fff;
                    font-size: 26px;
                    font-weight: 600;
                    margin-bottom: 6px;
                }
                .type-desc {
                    position: relative;
                    z-index: 2;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .type-info {
                        color: #fff;
                        font-size: 14px;
                        line-height: 22px;
                        margin-right: 20px;
                        // white-space: pre-wrap;
                        overflow: hidden;
                        div {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                    .type-btn {
                        width: 90px;
                        height: 34px;
                        background: #FE5B7B;
                        border-radius: 6px 6px 6px 6px;
                        opacity: 1;
                        text-align: center;
                        line-height: 34px;
                        font-size: 24px;
                        font-weight: 600;
                        color: #fff;
                        font-size: 16px;
                    }
                }
            }
        }
        &-inside {
            margin-top: 30px;
        }

        &-nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 30px;
            line-height: 30px;
            margin-bottom: 30px;

            &__list {
                display: flex;
                align-items: center;

                li {
                    cursor: pointer;
                    @include font(rgba(39, 44, 64, 1), 20px, 600);

                    &:not(:first-child) {
                        margin-left: 40px;
                    }

                    &:hover,
                    &.active {
                        @include font(rgba(44, 84, 239, 1), 20px, 600);
                    }
                }
            }

            &__update {
                padding: 0 15px;
                border-radius: 15px;
                background-color: rgba(44, 84, 239, 1);
                @include font(rgba(255, 255, 255, 1), 16px, 400);
                cursor: pointer;
                transition: all 0.3s;
                &:hover {
                    background-color: #597ef7;
                }
            }
        }
    }

    .aside {
        width: 300px;
        margin-left: 20px;
        position: relative;

        &-item:not(:first-child) {
            margin-top: 10px;
        }
    }
}

// 小屏
@include mq($small) {
    .home-wrapper {
        .home {
            width: 1200px;
            &-type {
                height: 146px;
                .type-item {
                    width: 301px;
                    height: 146px;
                    // padding: 10px;
                    img {
                        position: absolute;
                        left: center;
                        top: center;
                        height: 100%;
                        border-radius: 8px;
                        z-index: 1;
                    }
                    .type-title {
                        font-size: 18px;
                    }
                    .type-desc {
                        .type-info {
                            font-size: 12px;
                            line-height: 22px;
                            margin-right: 10px;
                            overflow: hidden;

                            text-overflow: ellipsis;

                            display: -webkit-box;

                            -webkit-line-clamp: 2; //2行

                            -webkit-box-orient: vertical;
                        }
                        .type-btn {
                            width: 70px;
                            height: 26px;
                            line-height: 26px;
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        .aside {
            width: 225px;
            margin-left: 18px;
        }
    }
}
@include mq($smaller) {
    .home-wrapper {
        .home {
            width: unset;
        }
        .aside {
            width: 225px;
            margin-left: 18px;
        }
    }
}
</style>
